import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  TextField,
} from "@mui/material";
import { SERVICE_SCOPE } from "../../../utils/constants";
import { Log, sendDataWithPost } from "../../../services/services";
import { showSuccessMsg } from "../../../utils/toast";
import { SingleSelectType } from "../../table/Filter";
import Quill from "../wysiwyg-html-editor";
import FormDialog from "../../FormDialog";

function EditDialog({
  open,
  queryPage,
  selectedId,
  getProductUpdateById,
  handleCloseDialog,
}) {
  const [data, setData] = useState();

  const handleClose = () => {
    handleCloseDialog();
    setData();
  };

  useEffect(() => {
    if (selectedId && open) getProductUpdateById(selectedId, setData);
  }, [selectedId, open]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      ...values,
      description: `<pre>${values.description}</pre>`,
      action: "update",
      pk: selectedId,
      title: values.title.trim()
    };
    const url = "/admins/product_update/request/";
    Log.info(`Click button [Update] - Update Product Update by Id: ${selectedId}`, { ...payload, description: "" });
    await sendDataWithPost(url, payload, null, null, (res) => {
      showSuccessMsg(res.data?.detail);
      handleClose();
      setSubmitting(false);
      resetForm();
      queryPage();
    });
  };

  if (!data) return <></>;

  return (
    <Formik
      initialValues={{
        title: data?.title,
        description: data?.description,
        service_scope: data?.service_scope,
      }}
      onSubmit={handleSubmit}
      validationSchema={Yup.object().shape({
        title: Yup.string().required("Required").trim(),
        description: Yup.string().required("Required"),
        service_scope: Yup.string().required("Required"),
      })}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleChange,
        handleSubmit,
        setFieldValue,
      }) => (
        <FormDialog
          open={open}
          onClose={handleClose}
          title="Edit Product update"
          handleSubmit={handleSubmit}
          loading={isSubmitting}
          maxWidth="sm"
        >
          <SingleSelectType
            label="Service scope"
            name="service_scope"
            options={SERVICE_SCOPE.map((item) => item)}
            selected={values.service_scope}
            onChange={(e) => handleChange(e)}
            variant="standard"
            error={Boolean(touched.service_scope && errors.service_scope)}
            helperText={touched.service_scope && errors.service_scope}
            disabled={isSubmitting}
          />

          <TextField
            label="Title"
            fullWidth
            variant="standard"
            name="title"
            value={values.title}
            error={Boolean(touched.title && errors.title)}
            helperText={touched.title && errors.title}
            onChange={(e) => handleChange(e)}
            sx={{ mb: 5 }}
            disabled={isSubmitting}
          />

          <Quill
            title="Description"
            value={values.description}
            helperText={touched.description && errors.description}
            onChange={(value) => setFieldValue("description", value)}
            sx={{ mb: 2 }}
          />
        </FormDialog>
      )}
    </Formik>
  );
}

export default EditDialog;
